import { render, staticRenderFns } from "./WorkClientPerson.vue?vue&type=template&id=2100d464&"
import script from "./WorkClientPerson.vue?vue&type=script&lang=js&"
export * from "./WorkClientPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports